import React, { Component } from 'react';
import { Field } from 'react-final-form';

export default class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={{ "box-shadow": "-1px 0px 12px -1px rgba(176,176,176,1)", "border-bottom": "1%" }}>
        <label style={{ width: "50%" }}>{this.props.question}</label>
        <div>
          <label>
            <Field
              name={this.props.question}
              component="input"
              type="radio"
              value="4"
            />{' '}
            Strongly Agree
              </label>
          <label>
            <Field
              name={this.props.question}
              component="input"
              type="radio"
              value="3"
            />{' '}
            Agree
              </label>
          <label>
            <Field
              name={this.props.question}
              component="input"
              type="radio"
              value="2"
            />{' '}
            Disagree
              </label>
          <label>
            <Field
              name={this.props.question}
              component="input"
              type="radio"
              value="1"
            />{' '}
            Strongly Disagree
              </label>
        </div>
      </div>
    )
  }
}